const cards = [
  {
    id: 1,
    number: "01",
    title: "I want to apply",
    detail:
      "Ask the admissions team about scholarships that are currently accepting applications.",
    linkLabel: "Check current opportunities",
    href: "mailto:admissions@utiva.co?subject=Current%20Utiva%20Scholarships",
  },
  {
    id: 2,
    number: "02",
    title: "I want to fund access",
    detail:
      "Sponsor a defined group, geography or capability pathway through Utiva Impact.",
    linkLabel: "Talk to the Impact team",
    href: "mailto:impact@utiva.co?subject=Fund%20a%20Utiva%20Scholarship",
  },
  {
    id: 3,
    number: "03",
    title: "I represent a community",
    detail:
      "Explore a partnership for beneficiary outreach, learner support and local access.",
    linkLabel: "Propose a partnership",
    href:
      "mailto:impact@utiva.co?subject=Scholarship%20Community%20Partnership",
  },
];

const ScholarshipOpportunitySection = () => {
  return (
    <section
      className="w-full py-16 lg:py-[105px] px-6 lg:px-8"
      style={{
        backgroundColor: "#fff9eb",
        backgroundImage:
          "linear-gradient(rgba(5,7,148,0.035) 1px, transparent 1px), linear-gradient(90deg, rgba(5,7,148,0.035) 1px, transparent 1px)",
        backgroundSize: "64px 64px",
      }}
    >
      <div className="container mx-auto">
        <div className="scholarship-grid-heading grid items-end gap-5 lg:gap-20 mb-10 lg:mb-12">
          <div>
            <p className="flex items-center gap-3 text-primary font-poppins text-sm font-extrabold tracking-widest uppercase mb-5">
              <span className="w-8 h-1 rounded-full bg-secondary inline-block"></span>
              Be Part of the Next Opportunity
            </p>
            <h2
              className="text-primary font-poppins font-bold tracking-[-0.045em] m-0"
              style={{ fontSize: "clamp(32px, 4vw, 55px)", lineHeight: 1.12 }}
            >
              There is a role for learners, funders and communities.
            </h2>
          </div>
          <p className="text-gray font-poppins text-[17px] leading-[1.8] m-0">
            Current availability should always be confirmed before applying.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {cards.map((card) => (
            <article
              key={card.id}
              className="flex flex-col min-h-[245px] lg:min-h-[280px] p-7 rounded-[21px]"
              style={{
                background: "rgba(255,255,255,0.96)",
                border: "1px solid #e6dcc3",
                boxShadow: "0 14px 38px rgba(31,34,48,0.051)",
              }}
            >
              <span className="text-[#9a6500] font-poppins tracking-[0.05em] text-sm font-extrabold">
                {card.number}
              </span>
              <h3 className="text-primary font-poppins font-bold tracking-[-0.025em] text-[22px] leading-[1.32] mt-12 mb-2.5">
                {card.title}
              </h3>
              <p className="text-gray font-poppins text-base leading-[1.72] m-0">
                {card.detail}
              </p>
              <a
                href={card.href}
                className="text-primary font-poppins font-extrabold text-[15px] mt-auto pt-5 hover:opacity-80 transition-opacity"
              >
                {card.linkLabel} <span aria-hidden="true">↗</span>
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ScholarshipOpportunitySection;
